export default __webpack_public_path__ + "static/media/ibnsalman0.093579d9.jpg";